import { routeConfig } from './theSafeHome';


export default function routes($routeProvider, $locationProvider) {
  $locationProvider.hashPrefix('');
  $routeProvider.when(
    '/home/viewReport/:reportInstanceId',
    routeConfig
  ).when(
    '/home',
    routeConfig
  ).when(
    '/',
    routeConfig
  );
}

routes.$inject = ['$routeProvider', '$locationProvider'];
console.log('app.components.home.routes loaded');
